import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useViewport } from "@cinch-labs/shared-util";
import { VehicleCardsList } from "./cards";
import { Carousel } from "./carousel/carousel";
import { TabButton, TabButtonList, TabPanel, Tabs } from "./tabs/tabs";
import { TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
export var RecentAndRecommendedVehicles = function(param) {
    var recentlyViewedListings = param.recentlyViewedListings, similarListings = param.similarListings;
    var vw = useViewport({
        updateOnResize: true,
        updateOnOrientationChange: true
    }).vw;
    var trackEvent = useAnalytics().trackEvent;
    useEffect(function() {
        trackEvent({
            eventName: "Welcome back module",
            type: TrackingEventTypes.ADOBE,
            data: {
                event: {
                    category: "welcome-back-module",
                    label: "personalised-component",
                    action: "triggered",
                    name: "load"
                }
            }
        });
    }, []);
    var isDesktop = vw >= 1024;
    var isTablet = vw >= 768 && vw < 1024;
    var isMobile = vw < 768;
    var hasVehicleListingsData = recentlyViewedListings && (recentlyViewedListings === null || recentlyViewedListings === void 0 ? void 0 : recentlyViewedListings.length) >= 1 && similarListings && (similarListings === null || similarListings === void 0 ? void 0 : similarListings.length) >= 1;
    if (hasVehicleListingsData) {
        var showRecentlyViewedCarousel = isMobile || isTablet && (recentlyViewedListings === null || recentlyViewedListings === void 0 ? void 0 : recentlyViewedListings.length) >= 2 || isDesktop && (recentlyViewedListings === null || recentlyViewedListings === void 0 ? void 0 : recentlyViewedListings.length) >= 4;
        var slidesPerView = isMobile ? 1 : isTablet ? 2 : 3;
        return /*#__PURE__*/ _jsxs(Tabs, {
            children: [
                /*#__PURE__*/ _jsxs(TabButtonList, {
                    children: [
                        /*#__PURE__*/ _jsx(TabButton, {
                            tabOrderNumber: 1,
                            children: "Recently viewed"
                        }),
                        /*#__PURE__*/ _jsx(TabButton, {
                            tabOrderNumber: 2,
                            children: "You might like"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(TabPanel, {
                    tabOrderNumber: 1,
                    children: showRecentlyViewedCarousel ? /*#__PURE__*/ _jsx(Carousel, {
                        slidesPerView: slidesPerView,
                        carouselName: "recently-viewed-cars",
                        vehicles: recentlyViewedListings
                    }) : /*#__PURE__*/ _jsx(VehicleCardsList, {
                        vehicles: recentlyViewedListings,
                        carouselName: "recently-viewed-cars"
                    })
                }),
                /*#__PURE__*/ _jsx(TabPanel, {
                    tabOrderNumber: 2,
                    children: /*#__PURE__*/ _jsx(Carousel, {
                        slidesPerView: slidesPerView,
                        carouselName: "you-might-like",
                        vehicles: similarListings
                    })
                })
            ]
        });
    } else {
        return null;
    }
};
